import { useEffect } from 'react'

import Bugsnag from '@bugsnag/js'
import { useMatches } from 'react-router'

interface UseBugsnagContextOptions {
  userId?: string
  orgId?: string
}

// Tags Bugsnag events with who/where they happened. Only ids are sent, never email or names.
export const useBugsnagContext = ({ userId, orgId }: UseBugsnagContextOptions): void => {
  const routeId = useMatches().at(-1)?.id

  useEffect(() => {
    if (!Bugsnag.isStarted()) { return }
    Bugsnag.setUser(userId)
  }, [userId])

  useEffect(() => {
    if (!Bugsnag.isStarted()) { return }
    Bugsnag.addMetadata('app', { orgId })
  }, [orgId])

  useEffect(() => {
    if (!Bugsnag.isStarted() || !routeId) { return }
    Bugsnag.setContext(routeId)
  }, [routeId])
}
